export default __webpack_public_path__ + "c283f56739ee3d10dd9130486314b447.png";